namespace JupitersChoice {
    export class SpinReelsCmd {

        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('FreeSpinsPromoModel') _freeSpinsPromoModel: Sapphire.FreeSpinsPromoModel;
        @inject('GameConfig') _gameConfig: Sapphire.GameConfig;
        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('SpinModel') _spinModel: Sapphire.SpinModel;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('TranslationsManager') _translationsManager: Sapphire.TranslationsManager;
        @inject('UserModel') _userModel: Sapphire.UserModel;

        execute(): void {
            this._spinModel.spinStarted();
            this._spinModel.disableSpinAction();

            const response: any = this._server.logicResponse;
            const commonUI = this._componentManager.get('CommonUI');
            const winMeter = <Sapphire.Meter>this._componentManager.get('WinMeter');
            const reels = this._componentManager.get('Reels');
            const cycler = this._componentManager.get('Cycler');
            const paylineDisplay = this._componentManager.get('PaylineDisplay');

            commonUI.disable();
            cycler.kill();
            paylineDisplay.clear();
            reels.spin();

            // Only reset the win meter on a new base game spin and is not a promo spin
            if (this._stateModel.currentSubgame === 'BaseGame' && !this._freeSpinsPromoModel.isInProgress) {
                winMeter.setValue(this._currencyFormatter.format(0));
            }

            this._soundManager.play('button_spin');

            if (this._stateModel.currentSubgame === 'FreeGame') {
                this._eventManager.publish('onHideSkipPaylinesButton');
                this._eventManager.publish('onSetFreeGameRestorePoint');
                this._eventManager.publish('onResetFreeGameReelCrumbles')

                let freeSpinCountText = this._translationsManager.get('framework.xofy').replace('{0}', ShowFreeGameCmd.currentFreeGameSpinIdx);
                freeSpinCountText = freeSpinCountText.replace('{1}', response.feature.value);
                this._componentManager.get('FreeSpinsCounter').setText(freeSpinCountText);

                // During free game we'll move the game state forward manually as we already have a server response at this point
                TweenMax.delayedCall(1, () => {
                    this._eventManager.publish('onCheckMegaHit');
                });
            }

            if (this._stateModel.currentSubgame === 'BaseGame') {
                for (let i = 0; i <= 5; i++) {
                    this._componentManager.get(`ReelCrumble${i}`).reset();
                }
                for (let i = 3; i <= 5; i++) {
                    this._componentManager.get(`ReelGlow${i}`).hide();
                    this._componentManager.get(`ReelGlow${i}`).stop();
                }
            }
        }
    }
}